import { Theme } from "@mui/material";

// export const KPI_OPTIONS = ["occupancy", "adr", "revpar"];
// export const KPI_LABEL_MAP: Record<string, string> = {
//   adr: "ADR",
//   revpar: "RevPar",
//   occupancy: "Occupancy",
// };

export interface KpiConfigItem {
  label: string;
  unit: string;  
  symbol: string; 
  position: "prefix" | "suffix";
  axisLabel: string;
}

export const MASTER_KPI_CONFIG: Record<string, KpiConfigItem> = {
  occupancy: {
    label: "Occupancy",
    unit: "%",
    symbol: "%",
    position: "suffix",
    axisLabel: "Occupancy (%)",
  },
  adr: {
    label: "ADR",
    unit: "USD",
    symbol: "$",  
    position: "prefix",
    axisLabel: "ADR ($)",
  },
  revpar: {
    label: "RevPAR",
    unit: "USD",
    symbol: "$",  
    position: "prefix",
    axisLabel: "RevPAR ($)",
  },
};

export const KPI_OPTIONS = Object.keys(MASTER_KPI_CONFIG);

export const KPI_LABEL_MAP = Object.entries(MASTER_KPI_CONFIG).reduce((acc, [key, config]) => {
  acc[key] = config.label;
  return acc;
}, {} as Record<string, string>);

export const DEFAULT_KPI_CONFIG: KpiConfigItem = {
  label: "Metric",
  unit: "",
  symbol: "",
  position: "suffix",
  axisLabel: "Value",
};

export const getKpiConfig = (kpi: string): KpiConfigItem => {
  const config = MASTER_KPI_CONFIG[kpi];
  
  if (config) return config;

  return {
    ...DEFAULT_KPI_CONFIG,
    label: kpi.replace(/_/g, " ").toUpperCase(),
  };
};

export const formatKpiValue = (value: number, kpi: string) => {
    const config = getKpiConfig(kpi);
    const num = Number(value).toFixed(2);
    return config.position === 'prefix' 
        ? `${config.symbol}${num}` 
        : `${num}${config.symbol}`;
};


export const extractNarration = (results: any) => {
  if (!results) return "I analyzed the data but found no specific results.";
  return Object.keys(results)
    .map((kpi) => results[kpi]?.narration || "")
    .filter(Boolean)
    .join("\n\n");
};

export const responsiveControlStyle = {
  flex: { xs: "1 0 120px", sm: "0 0 auto" },
  minWidth: "120px",
};

export const getCommonStyles = (theme: Theme) => {
  const primaryMain = theme.palette.primary.main;

  return {
    height: "40px",
    borderRadius: "20px",

    backgroundColor: "white",
    border: `1px solid ${primaryMain}`,
    color: primaryMain,

    fontSize: "0.85rem",
    fontWeight: 500,
    boxShadow: 2,

    "&:hover": {
      backgroundColor: "#f5f9ff",
      borderColor: theme.palette.primary.dark,
    },
  };
};

export const getSelectStyles = (theme: Theme) => {
  const common = getCommonStyles(theme);

  return {
    ...common,
    width: "100%",

    "& .MuiOutlinedInput-notchedOutline": { border: "none" },

    "& .MuiSelect-icon": { color: common.color },

    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      paddingTop: "10px",
      paddingBottom: "10px",
      height: "100%",
      paddingLeft: "16px",
      paddingRight: "32px !important",
    },
  };
};